import React, { useEffect } from 'react';
import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { Skeleton } from '@mui/material';
import ContainerContent from './ContainerContent';
import NotFoundEmpty from './notFoundEmpty/notFoundEmpty';
import GlobalContext from './GlobalContext';
import { getHashObj } from '../components/getSubjectId';
import { GlobalVariable, fetchRecommendations, checkIfEmpty } from '../utils/appHelpers';

// Constants
export const PUBLIC_ROUTES = ['/login', '/register', '/register-success', '/forgot-password', '/verify-email', '/reset-password'];

// Components
export const RootCalcWrapper: React.FC = () => {
  const [globalVariable, setGlobalV] = React.useState<GlobalVariable>({});
  const [loading, setLoading] = React.useState(true);
  const obj = getHashObj();

  useEffect(() => {
    const fetchData = async () => {
      const response = await fetchRecommendations(obj);
      setGlobalV(response);
      setLoading(false);
    };

    fetchData();
  }, []);

  const isEmpty = checkIfEmpty(obj);

  if (loading) {
    return (
      <ContainerContent>
        <div data-animch>
          <div className={'emptyPadding'} style={{ boxSizing: 'border-box', textAlign: 'center', animationDelay: '1s' }}>
            <Skeleton />
            <Skeleton animation='wave' width={'100%'} />
            <Skeleton animation={false} width={'100%'} />
            <Skeleton />
            <Skeleton animation='wave' width={'100%'} />
            <Skeleton animation={false} width={'100%'} />
            <Skeleton />
            <Skeleton animation='wave' width={'100%'} />
            <Skeleton animation={false} width={'100%'} />
          </div>
        </div>
      </ContainerContent>
    );
  }

  if (isEmpty) {
    return (
      <div>
        <NotFoundEmpty />
      </div>
    );
  }

  return (
    <GlobalContext.Provider value={globalVariable}>
      <Outlet />
    </GlobalContext.Provider>
  );
};

export const RootRedirect: React.FC = () => {
  const navigate = useNavigate();
  
  useEffect(() => {
    navigate('/home', { replace: true });
  }, [navigate]);
  
  return null;
};

export const ContainerWrapper: React.FC = () => {
  return (
    <div className={'paddTs paddBs'}>
      <div>
        <div data-animch data-main>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export const ScrollToTopWrapper: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    console.log('Location changed:', location.pathname);
    window.scrollTo({
      top: 0,
    });
  }, [location.pathname]);

  return null;
};

export const AuthGuard: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const location = useLocation();
  const isLoggedIn = Boolean(localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken'));

  if (!isLoggedIn && !PUBLIC_ROUTES.includes(location.pathname)) {
    return <Navigate to="/login" replace />;
  }
  
  if (isLoggedIn && PUBLIC_ROUTES.includes(location.pathname)) {
    return <Navigate to="/" replace />;
  }
  
  return children;
};
